import React, { forwardRef } from 'react';

import FadeIn from 'src/components/elements/FadeIn';

import { TravelLoyaltyItems } from '../../constants';
import IconBlock from './IconBlock';

import styles from './TravelLoyalty.scss';

const TravelLoyalty = forwardRef<HTMLDivElement, React.ComponentPropsWithRef<'div'>>(
  (props, ref) => (
    <section
      data-locator="partnersTravelLoyalty"
      ref={ref}
      className={styles.travelLoyaltyContainer}
    >
      <FadeIn delay={0.2}>
        <h2 className={styles.travelLoyaltyTitle}>
          <span className={styles.travelLoyaltyTitleThin}>Travel loyalty</span> designed
          for&nbsp;you
        </h2>
      </FadeIn>
      <FadeIn delay={0.4}>
        <p className={styles.travelLoyaltySubTitle}>
          Solartrip provides plug-and-play white-label and loyalty software for&nbsp;big consumer
          businesses to&nbsp;boost customer acquisition and&nbsp;engagement
        </p>
      </FadeIn>
      <FadeIn delay={0.6} className={styles.iconsContainer}>
        {TravelLoyaltyItems.map((item) => {
          return (
            <React.Fragment key={item.id}>
              <hr className={styles.line} />
              <IconBlock item={item} />
            </React.Fragment>
          );
        })}
      </FadeIn>
    </section>
  )
);

export default TravelLoyalty;
